import { type ReactNode, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $accountByIdStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';
import { ModalItem } from '../../../pages/account/widgets/modalItem';
import { Button, Icon, Modal, Text } from '@shared/widgets';
import SendIcon from '@assets/icons/send.svg';
import CopyIcon from '@assets/icons/copy.svg';

interface Value {
  name: ReactNode;
  value?: ReactNode;
}
interface AccountDetailsModalProps {
  isOpen: boolean;
  values: Value[];
  onClose: () => void;
}

export const AccountDetailsModal = (props: AccountDetailsModalProps) => {
  const accountDetailsStore = useUnit($accountByIdStore.store);

  const [email, setEmail] = useState<string>('');

  const { t } = useTranslation('account');

  const copyHandler = async () => {
    const valuesToCopy = props.values.map((item) => `${item.name}\n${item.value ? item.value : ''}`).join('\n\n');
    await navigator.clipboard.writeText(valuesToCopy);
  };
  const mail = props.values.map((item) => `${item.name}: ${item.value ? item.value : ''}%0A%0A`).join('\n\n');
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={t('details.modals.accountDetails.title')}>
      <div className='max-w-96'>
        <div className='mt-4 flex flex-col gap-4'>
          {props.values?.map((item, idx) => (
            <ModalItem
              key={idx}
              name={item.name}
              value={item.value}
              icon={<Icon color={PaletteUtils.isInsigniaPalette ? 'primary' : undefined} icon={<CopyIcon />} />}
            />
          ))}
        </div>
        <div className='mb-5 mt-6'>
          <Text className='mb-1.5' color='secondary'>
            {t('details.modals.accountDetails.sendToEmail')}
          </Text>
          <form className='flex' onSubmit={(e) => e.preventDefault()}>
            <input
              className='h-10 w-full bg-white pl-3 shadow-md dark:bg-soft-black'
              type='email'
              placeholder={t('placeholders.email', { ns: 'common' })}
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              className='rounded-bl-none rounded-br-sm rounded-tl-none rounded-tr-sm'
              color='primary'
              type='submit'
              to={email ? `mailto:${email}?subject=Details of account ${accountDetailsStore.data?.name}&body=${mail}` : undefined}
            >
              <Icon icon={<SendIcon />} color='inherit' />
            </Button>
          </form>
        </div>
        <div className='flex justify-between gap-3'>
          <Button fullWidth color='outlined' onClick={copyHandler}>
            <Icon icon={<CopyIcon />} color='inherit' />
            {t('details.modals.accountDetails.buttons.copyToClipboard')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
